import React from "react";
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";

import useWindowSize from "components/shared/WindowResize";
import { setIsLoading } from "redux/loader/action";
import { setCurrentUser } from "redux/game/action";
import MyTeam from "./components/MyTeam";
import MyAvatar from "./components/MyAvatar";
import PlayerSound from "./components/PlayerSound";
import ProfileSettings from "./components/ProfileSettings";
import SideBarTabs from "../landingLibrary/sideBarTabs";

const Account = ({ history }) => {
  const dispatch = useDispatch();
  const { width } = useWindowSize();

  const {
    gameReducer: { currentUser },
    paramsReducer: { audioObj: { audio_effects } = {} }
  } = useSelector((state) => state);

  const handleIsLoading = (value) => dispatch(setIsLoading(value));

  const handleSetCurrentUser = (name, value) =>
    dispatch(setCurrentUser({ ...currentUser, [name]: value }));

  return (
    <Row className="team-ch-row">
      <Col md={1} lg={1} className="p-0">
        <SideBarTabs
          current_user={currentUser}
          handleOptClick={() => history.push("/outside_team_building")}
        />
      </Col>
      <Col md={11} lg={11}>
        <main className="account-main">
          <section className="account-header">
            <Breadcrumb>
              <BreadcrumbItem>
                <a href="/">Home</a>
              </BreadcrumbItem>
              <BreadcrumbItem active>Billing</BreadcrumbItem>
            </Breadcrumb>
            <h2 className="heading">Billing & Team Plan</h2>
            <p className="info">
              Discover team activities to bond, learn, and grow as a team.
            </p>
          </section>
          <Row>
            <Col md={width < 1700 ? 8 : 9} lg={width < 1700 ? 8 : 9}>
              <ProfileSettings
                history={history}
                dispatch={dispatch}
                currentUser={currentUser}
                handleIsLoading={handleIsLoading}
                handleSetCurrentUser={handleSetCurrentUser}
              />
            </Col>
            <Col md={width < 1700 ? 4 : 3} lg={width < 1700 ? 4 : 3}>
              <div className="profile-img-outer">
                <MyAvatar
                  profileImg={currentUser.picture}
                  handleIsLoading={handleIsLoading}
                  handleSetCurrentUser={handleSetCurrentUser}
                />
                <MyTeam
                  history={history}
                  currentUser={currentUser}
                  handleIsLoading={handleIsLoading}
                  handleSetCurrentUser={handleSetCurrentUser}
                />
              </div>
            </Col>
          </Row>
          <Row style={{ margin: "0" }}>
            <PlayerSound
              audioData={audio_effects}
              audio_url={currentUser.audio_url}
              handleIsLoading={handleIsLoading}
              handleSetCurrentUser={handleSetCurrentUser}
            />
          </Row>
        </main>
      </Col>
    </Row>
  );
};

export default Account;
